import { Box, HStack, Wrap } from "@chakra-ui/react";
import { FC } from "react";

import { PopupVideoSourceKind } from "~/src/__generated__/schema";
import { uploadedVideoPreviewStyle } from "~/src/components/features/popup/PopupGroupPatternForm/presentations/PopupVideoForm/popupVideoFormUtils";
import { chakraFactory } from "~/src/lib/chakra-ui";

export type Props = {
  videoSource?: PopupVideoSourceKind | null;
  youtubeUrl?: string | null;
  playbackUrl?: string | null;
};

const StyledFlexWrapperBox = chakraFactory(Box, {
  baseStyle: {
    width: "100%",
    display: "flex",
    marginBottom: "8px",
  },
});

const StyledContentWrap = chakraFactory(Wrap, {
  baseStyle: {
    flex: "1",
    margin: "auto 0",
    fontSize: "12px",
    lineHeight: "17px",
    color: "#282828",
  },
});

const StyledMediaWrap = chakraFactory(Box, {
  baseStyle: {
    alignSelf: "baseline",
  },
});

const StyledVideo = chakraFactory("video", {
  baseStyle: {
    ...uploadedVideoPreviewStyle,
    marginTop: "4px",
  },
});

const StyledLabelText = chakraFactory("span", {
  baseStyle: {
    height: "22px",
    fontSize: "13px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
  },
});

const toYoutubeEmbedUrl = (url: string) =>
  url.replace("watch?v=", "embed/").replace("youtu.be/", "youtube.com/embed/");

export const PopupPatternDetailVideoContainer: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ videoSource, youtubeUrl, playbackUrl }) => {
  const isUploaded = videoSource === "UPLOADED";
  const label = isUploaded ? "アップロード動画" : "動画のURL";
  const displayUrl = isUploaded ? playbackUrl : youtubeUrl;

  return (
    <StyledFlexWrapperBox>
      <HStack
        spacing="8px"
        w={[120, 180, 230]}
        height="40px"
        alignItems="center"
      >
        <StyledLabelText>{label}</StyledLabelText>
      </HStack>
      <StyledContentWrap>
        {displayUrl ? (
          <StyledMediaWrap>
            {isUploaded ? (
              <StyledVideo src={displayUrl} controls muted />
            ) : (
              <iframe title="popupVideo" src={toYoutubeEmbedUrl(displayUrl)} />
            )}
          </StyledMediaWrap>
        ) : (
          <Box>設定されていません</Box>
        )}
      </StyledContentWrap>
    </StyledFlexWrapperBox>
  );
};
